/**
 * Hook for checking if the current user has a specific RBAC permission.
 *
 * Usage:
 *   const canEditPersonas = usePermission('personas:update')
 *   const canAccessAdmin = usePermission('admin:access')
 */

import { usePermissionStore } from '@/stores/permissionStore'

export function usePermission(permission: string): boolean {
  return usePermissionStore((s) => s.hasPermission(permission))
}

export function useCan(action: string, resource: string): boolean {
  return usePermission(`${resource}:${action}`)
}
